module.exports = __webpack_public_path__ + "static/img/cont38 (2).67ceef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont38 (2).png
// module id = unMI
// module chunks = 0